import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Hero from "../../components/home/Hero";
import Ecosystem from "../../components/home/Ecosystem";
import Roles from "../../components/home/Roles";
import Benefits from "../../components/home/Benefits";
import Process from "../../components/home/Process";
import Life from "../../components/home/Life";
import FAQ from "../../components/home/FAQ";
import FinalCta from "../../components/home/FinalCta";
import { getJobs } from "../../lib/api";
import { T } from "../../theme";

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${T.bg};
`;

const Main = styled.main`
  flex: 1;
`;

/* Rola suavemente até a lista de vagas. */
const scrollToJobs = () => {
  const el = document.getElementById("vagas");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Home() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [apiErr, setApiErr] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getJobs()
      .then((d) => { setJobs(d); setApiErr(false); })
      .catch(() => { setJobs([]); setApiErr(true); })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Page>
      <Header />

      <Hero
        search={search}
        setSearch={setSearch}
        jobCount={jobs.length}
        loading={loading}
        onSeeJobs={scrollToJobs}
      />

      <Main id="main-content">
        <Ecosystem />
        <Roles jobs={jobs} loading={loading} apiErr={apiErr} search={search} />
        <Benefits />
        <Process />
        <Life />
        <FAQ />
        <FinalCta onSeeJobs={scrollToJobs} />
      </Main>

      <Footer />
    </Page>
  );
}
